/**
 * 求人トレンド用offsetをランダムで生成する処理
 * @param jobcount 求人数
 * @returns ランダムで生成したoffset
 */
export const createRandomOffset = (jobcount: number) => {
  const MAX_JOBCOUNT = 20;
  let randamOffset = 0;
  if (jobcount > MAX_JOBCOUNT) {
    randamOffset = Math.floor(Math.random() * (jobcount - MAX_JOBCOUNT + 1));
  }
  return randamOffset;
};
